import React from 'react';
import useRoute from '@/Hooks/useRoute';
import { Link } from '@inertiajs/react';

export default function PackageName({
  package: p,
  ...rest
}: {
  package: App.Data.PackageData;
  className?: string;
}) {
  const route = useRoute();
  return (
    <Link href={route('packages.show', p.id)} {...rest}>
      {p.name}
    </Link>
  );
}
